import { render, staticRenderFns } from "./OffersDetailPage.vue?vue&type=template&id=5fc07ef8&scoped=true&lang=pug&"
import script from "./OffersDetailPage.vue?vue&type=script&lang=js&"
export * from "./OffersDetailPage.vue?vue&type=script&lang=js&"
import style0 from "./OffersDetailPage.styl?vue&type=style&index=0&id=5fc07ef8&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fc07ef8",
  null
  
)

export default component.exports